import React from 'react';
import { Badge } from '@chakra-ui/react';

const STATE_PRESENTATION = {
    fresh: { label: 'Fresh', colorScheme: 'green' },
    ageing: { label: 'Ageing', colorScheme: 'orange' },
    stale: { label: 'Stale', colorScheme: 'gray' },
    unknown: { label: 'Freshness unknown', colorScheme: 'gray' },
};

const formatAge = ageDays => {
    if (ageDays === null || ageDays === undefined) return null;
    const numeric = Number(ageDays);
    if (!Number.isFinite(numeric)) return null;
    return `${numeric.toFixed(numeric % 1 === 0 ? 0 : 1)}d`;
};

export const freshnessLabel = freshness => {
    const state = freshness?.state || 'unknown';
    const presentation = STATE_PRESENTATION[state] || STATE_PRESENTATION.unknown;
    const age = formatAge(freshness?.age_days);
    return age ? `${presentation.label} · ${age}` : presentation.label;
};

export const freshnessPolicyLabel = freshness => {
    const warnDays = freshness?.thresholds?.warn_days;
    const staleDays = freshness?.thresholds?.stale_days;
    if (!Number.isFinite(Number(warnDays)) || !Number.isFinite(Number(staleDays))) {
        return 'Freshness thresholds unavailable';
    }
    return `Policy: ageing from ${warnDays} days; stale from ${staleDays} days`;
};

const ScoreFreshnessBadge = ({ freshness }) => {
    const state = freshness?.state || 'unknown';
    const presentation = STATE_PRESENTATION[state] || STATE_PRESENTATION.unknown;
    const label = freshnessLabel(freshness);
    const policyLabel = freshnessPolicyLabel(freshness);

    return (
        <Badge
            colorScheme={presentation.colorScheme}
            variant="subtle"
            fontSize="10px"
            borderRadius="full"
            px={2}
            py={0.5}
            title={policyLabel}
            aria-label={`${label}. ${policyLabel}`}
        >
            {label}
        </Badge>
    );
};

export default ScoreFreshnessBadge;
